import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=5352da2a&scoped=true&"
import script from "./detailsPage.js?vue&type=script&lang=js&"
export * from "./detailsPage.js?vue&type=script&lang=js&"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=5352da2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352da2a",
  null
  
)

export default component.exports